/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// ../~/lodash/_realNames.js
// module id = 1731
// module chunks = 1